export default {
    emitters: {
        tetraRadioConnect(params) {
            return new Promise((resolve, reject) => {
                //this.log('tetra-radio-connect: > ' + JSON.stringify(params))
                this.socket.emit('tetra-radio-connect', params, (result) => {
                    if (result.error || !result.status) {
                        this.log(`tetra-radio-connect: < failed ${result.error}`)
                        return reject(result.error)
                    }
                    resolve(result.status)
                })
            })
        },
        tetraRadioDisconnect(params = {}) {
            return new Promise((resolve, reject) => {
                //this.log('tetra-radio-disconnect: > ' + JSON.stringify(params))
                if (this.isConnected) {
                    this.socket.emit('tetra-radio-disconnect', params, (result) => {
                        if (result && result.error) {
                            this.log(`tetra-radio-disconnect: < failed ${result.error}`)
                            return reject(result.error)
                        }
                        resolve()
                    })
                } else resolve()
            })
        },
        tetraRadioGetStatus(params) {
            return new Promise((resolve, reject) => {
                //this.log('tetra-radio-get-status: > ' + JSON.stringify(params))
                this.socket.emit('tetra-radio-get-status', params, (result) => {
                    if (!result.status) {
                        this.log(`tetra-radio-get-status: < failed`)
                        return reject()
                    }
                    resolve(result.status)
                })
            })
        },
        tetraRadioSendCmd(params) {
            //this.log('tetra-radio-send-cmd: > ' + JSON.stringify(params))
            this.socket.emit('tetra-radio-send-cmd', params)
        },
    },
    listeners: {
        'tetra-radio-status-change-event'(data) {
            log('bind: < tetra-radio-status-change-event: ' + JSON.stringify(data))
            this.emit('tetra-radio-status-change-event', data)
        },
        'tetra-radio-message-event'(data) {
            log('bind: < tetra-radio-message-event: ' + JSON.stringify(data))
            this.emit('tetra-radio-message-event', data)
        },
    },
}